import { useSyncExternalStore } from 'react'

const emptySubscribe = () => () => {}

// Returns false during SSR/prerender and the first client render, then true
// after hydration. Use it to gate client-only UI (toasts, auth-dependent
// markup) so the first client paint matches the server HTML exactly — otherwise
// React throws a hydration mismatch, which can blank prerendered pages.
//
// Implemented with useSyncExternalStore (not a useEffect setState) so it stays
// hydration-correct and lint-clean: React uses getServerSnapshot (false) for the
// server + first client render, then switches to getSnapshot (true).
export function useHydrated(): boolean {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  )
}
